var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bar-chart',{attrs:{"title":"Sessions / j (moy)","subTitle":"par catégorie","colors":_vm.colors,"series":_vm.series,"labels":_vm.labels,"loading":_vm.loading,"datalabels":false,"yAxis":_vm.yAxis,"formatter":_vm.formatter,"outlined":""}})}
var staticRenderFns = []

export { render, staticRenderFns }